import React, { useContext, useEffect, useState } from "react";
import _ from "lodash";
import CheckBox from "../../../components/CheckBox/CheckBox";
import DownloadIcon from "../../../components/VectorIcons/DownloadIcon";
import SimpleButton from "../../../components/SimpleButton/SimpleButton";
import ListAttachments from "./ListAttachments";
import AppContext from "../../../context/appContext";
import "../ReleasedListAttachments/styles/ReleasedListAttachments.scss";
import useDownloadAttachment from "../../../hooks/useDownloadAttachment";
import { normalizeBlockFiles } from "../../AttachmentsScheduler/PlanningGrid/mappers/attachments";
import { Arrow } from "../../AttachmentsScheduler/PlanningGrid/Arrow/Arrow";

let order = [
  "Bíblia",
  "Bíblia/Projeto",
  "Capítulo/Episódio",
  "Episódio",
  "Escaleta",
  "Ideia/Argumento",
  "Material Complementar",
  "OnePage",
  "Perfil de Personagem",
  "Pré-Sinopse",
  "Projeto",
  "Promo",
  "Roteiro",
  "Roteiro Filme",
  "Sinopse/Arco de Temporada",
  "Roteiro de Episódio",
];

const returnTypeFilesAndOrder = (name) => {
  let enumFiles = {
    "Capítulo/Episódio": "chapterNumber",
    Episódio: "chapterNumber",
    default: "version",
  };
  return enumFiles[name] || enumFiles["default"];
};

const groupBy = (files) =>
  groupAllFiles(
    _.groupBy(
      files,
      (u) =>
        u.attachmentType?.name ??
        u.attachmentType?.attachment?.attachmentType?.name ??
        u.type?.name ??
        ""
    )
  );
const reorderFiles = (files, order) => _.orderBy(files, [order], ["asc"]);
const groupAllFiles = (files) => {
  const grouped = [];

  order.forEach((e) => {
    grouped.push(reorderFiles(files[e] || [], returnTypeFilesAndOrder(e)));
  });

  Object.keys(files)
    .filter((key) => !order.includes(key))
    .forEach((key) => {
      grouped.push(reorderFiles(files[key], returnTypeFilesAndOrder(key)));
    });

  return grouped.filter((g) => g.length);
};

const ReleasedListAttachmentsController = (props) => {
  const {
    files,
    title,
    type = "textReleased",
    contentId,
    blockNumber,
    isBlockMode,
    chaptersCount,
    plannedRelease,
    releasedAt,
    materialType,
    isAddendaBlockMode,
    addendaCount,
    isAddendaChapterMode,
    chapterNumber,
    chapterLabel = "Capítulo",
    isFirst,
    renameEpisodeLabel,
  } = props;

  const isAddendaMode = isAddendaChapterMode || isAddendaBlockMode;

  const [state, setState] = useState({
    files: [],
    filesGroups: [],
    compiledAttachments: [],
    projectAttachments: [],
  });
  const [collapsed, setCollapsed] = useState(true);
  const [stateAttachmentsForZip, setStateAttachmentForZip] = useState([]);
  const [checkAll, setCheckAll] = useState(false);
  const isReleased = (file) =>
    file.release ?? file.releaseManagement?.channel ?? false;

  const hasAttachments = state.filesGroups
    ?.flat?.()
    .some((f) => f?.fileId && isReleased(f));
  const appContext = useContext(AppContext);
  const { downloadAndZipMultipleAttachments } = useDownloadAttachment();
  const downloadableAttachments = state.filesGroups
    .flat()
    .filter((item) => item.fileId && isReleased(item));

  const populateListAttachmentForZip = (fileId, name, title, files, isAll) => {
    setStateAttachmentForZip((prevState) => [
      ...prevState,
      {
        ...files,
        name: name,
        fileId: fileId,
      },
    ]);
  };

  const toggleCollapse = () => {
    setCollapsed((prev) => !prev);
  };

  const removeAttachmentsForZip = (fileId) => {
    setStateAttachmentForZip(
      (prevState) => [...prevState].filter((e) => e.fileId !== fileId) ?? []
    );
  };

  const SingleToggleActive = (index, i, bool) => {
    const newState = { ...state };
    newState.filesGroups[index][i].isActive = !bool
      ? !newState.filesGroups[index][i].isActive
      : bool;
    setState(newState);
  };

  const handleChangeFiles = (fileId, name, title, files, isAll, index, i) => {
    SingleToggleActive(index, i);
    if (!stateAttachmentsForZip.filter((e) => e.fileId === fileId).length) {
      populateListAttachmentForZip(fileId, name, title, files, isAll);
    } else {
      removeAttachmentsForZip(fileId, title);
    }
  };

  const populateAllState = (files) => {
    !checkAll ? setStateAttachmentForZip(files) : setStateAttachmentForZip([]);
    setState({ ...state, ...state.filesGroups });
    setCheckAll(!checkAll);
  };

  const handleCheckAll = () => {
    let a = [];

    const allFiles = state.filesGroups.flat();

    const selectableFiles =
      type === "channels"
        ? allFiles.filter((f) => f.fileId && isReleased(f))
        : allFiles.filter((f) => f.fileId && isReleased(f));

    selectableFiles.forEach((file) => {
      file.isActive = !checkAll;
      a.push(file);
    });

    populateAllState(a);
  };

  const downloadAllCallback = () => {
    setCheckAll(!checkAll);
    setStateAttachmentForZip([]);
  };

  const downloadAll = () => {
    downloadAndZipMultipleAttachments({
      contentId,
      filesArray: stateAttachmentsForZip,
      origin: "textos-liberados",
      mode: 0,
      title: title,
      setLoading: appContext.setShowGlassLoading,
      callback: downloadAllCallback,
    });
  };

  useEffect(() => {
    const normalizedFiles = normalizeBlockFiles(files);

    setState((prevState) => ({
      ...prevState,
      files: normalizedFiles,
      projectAttachments: normalizedFiles,
    }));
  }, [files]);

  useEffect(() => {
    if (!!state.projectAttachments?.length)
      setState((prevState) => ({
        ...prevState,
        compiledAttachments: prevState.projectAttachments?.map(
          (attachment) => ({ ...attachment, isActive: false })
        ),
      }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.projectAttachments]);

  useEffect(() => {
    if (!!state.compiledAttachments.length)
      setState((prevState) => ({
        ...prevState,
        filesGroups: groupBy(state.compiledAttachments),
      }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.compiledAttachments]);

  const formatDate = (date) => {
    if (!date) return "-";

    return new Date(date).toLocaleDateString("pt-BR");
  };

  useEffect(() => {
    const allFiles = state.filesGroups.flat();

    const totalDownloadableFiles = allFiles.filter(
      (f) => f.fileId && isReleased(f)
    ).length;

    const selectedCount = stateAttachmentsForZip.length;

    const shouldBeAllSelected =
      totalDownloadableFiles > 0 && selectedCount === totalDownloadableFiles;

    setCheckAll(shouldBeAllSelected);
  }, [stateAttachmentsForZip, state.filesGroups]);

  const renderAttachmentsContent = () => (
    <>
      {hasAttachments && (
        <ul
          className={
            type === "channels"
              ? "releaseAttachmentsHeader"
              : "attachmentsHeader"
          }
        >
          <li className="type">
            {!!downloadableAttachments?.length && (
              <div>
                <CheckBox isActive={checkAll} event={handleCheckAll} />
              </div>
            )}
            Tipo
          </li>
          {!isAddendaMode && <li className="version">Versão</li>}
          <li className="fileComment">
            {isAddendaMode ? "Arquivo" : "Título/Observações"}
          </li>
          {isAddendaMode && <li className="fileComment">Associações</li>}
          <li className="receivedAt">Liberado Em</li>
          <li />
        </ul>
      )}

      {state.filesGroups?.length > 0 &&
        state.filesGroups.map((_files, index) => (
          <div key={index}>
            {_files.map(
              (file, i) =>
                (type === "textReleased" || !!file.fileId) && (
                  <ListAttachments
                    file={file}
                    index={i}
                    parentIndex={index}
                    title={title}
                    key={i}
                    handleChangeFiles={handleChangeFiles}
                    type={type}
                    contentId={contentId}
                    renameEpisodeLabel={renameEpisodeLabel}
                  />
                )
            )}
          </div>
        ))}

      {!hasAttachments && (
        <div className="attachmentItem" style={{ margin: "6px 0" }}>
          <div className="mainVersionItem">
            <p
              className="fileNameAttachment"
              style={{
                color: "#575863",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flex: 1,
                marginTop: "6px",
              }}
            >
              {isAddendaBlockMode
                ? "Não há adendos liberados"
                : "Não há anexos liberados"}
            </p>
          </div>
        </div>
      )}

      {!!downloadableAttachments?.length && (
        <div className="footer" style={{ marginBottom: "6px" }}>
          <span>Selecione o(s) anexo(s) que deseja baixar</span>

          <SimpleButton
            text="Baixar selecionados"
            classButton="buttonBlue"
            dataQA="button-prospect-edit"
            onBreadcrumb={true}
            isValidForm={stateAttachmentsForZip.length > 0}
            toValidate={true}
            clickEvent={downloadAll}
          >
            <DownloadIcon color="#fff" />
          </SimpleButton>
        </div>
      )}
    </>
  );

  return (
    <div className="ReleasedListAttachments">
      {isAddendaChapterMode ? (
        <>
          <div className="attachmentItem">
            <div className="mainVersionItem">
              <div className="releaseGridRow">
                <div className="colType blockNumber">
                  <span
                    onClick={toggleCollapse}
                    style={{
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: 48,
                      height: 48,
                    }}
                  >
                    <Arrow isOpen={!collapsed} />
                  </span>

                  <strong>
                    {chapterLabel} {chapterNumber}
                  </strong>
                </div>

                <div className="colChapter">{addendaCount}</div>
              </div>
            </div>
          </div>

          {!collapsed && renderAttachmentsContent()}
        </>
      ) : isBlockMode ? (
        <>
          <div className="attachmentItem">
            <div className="mainVersionItem">
              <div className="releaseGridRow">
                <div className="colType blockNumber">
                  <span
                    onClick={toggleCollapse}
                    style={{
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: 48,
                      height: 48,
                    }}
                  >
                    <Arrow isOpen={!collapsed} />
                  </span>

                  <strong>Bloco {blockNumber}</strong>
                </div>

                <div className="colChapter">{chaptersCount}</div>

                <div className="colPlanned">{formatDate(plannedRelease)}</div>

                <div className="colReleased">{formatDate(releasedAt)}</div>
              </div>
            </div>
          </div>

          {!collapsed && renderAttachmentsContent()}
        </>
      ) : materialType ? (
        <>
          {isFirst && (
            <ul className="materialsHeader">
              <li className="colType">TIPO DE MATERIAL</li>
              <li className="colChapter"></li>
              <li className="colPlanned">LIBERAÇÃO PLANEJADA</li>
              <li className="colReleased">LIBERADO EM</li>
            </ul>
          )}

          <div className="attachmentItem">
            <div className="mainVersionItem">
              <div className="releaseGridRow">
                <div
                  className=" colType materialType"
                  style={{
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <span
                    onClick={toggleCollapse}
                    style={{
                      cursor: "pointer",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: 48,
                      height: 48,
                    }}
                  >
                    <Arrow isOpen={!collapsed} />
                  </span>

                  <strong>{materialType}</strong>
                </div>

                <div className="colChapter"></div>

                <div className="colPlanned">{formatDate(plannedRelease)}</div>

                <div className="colReleased">{formatDate(releasedAt)}</div>
              </div>
            </div>
          </div>

          {!collapsed && renderAttachmentsContent()}
        </>
      ) : (
        renderAttachmentsContent()
      )}
    </div>
  );
};

export default ReleasedListAttachmentsController;
